import Vue from "vue";
import Vuex from "vuex";

//  modules
import global from "./modules/global";
import mixins from "./modules/mixin";
import download from "./modules/download";
import vModal from "./modules/vModal";
import users from "./modules/users";
import userCentered from "./modules/userCentered";
import listContent from "./modules/listContent";
import favorites from "./modules/favorites";
import triggerEvtents from "./modules/triggerEvtents";
import search from "./modules/search";

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        global,
        mixins,
        download,
        vModal,
        users,
        userCentered,
        listContent,
        favorites,
        search,
        triggerEvtents
    }
});
